<mat-card>
    <mat-card-header class="f-s-18 f-w-500">
        Previsioni meteo
    </mat-card-header>
    <mat-card-content>
        <app-weather [type]="'forecast'" />
    </mat-card-content>
</mat-card>
<app-forecast-lines />
<!-- <app-period-bars /> -->